import React from 'react';

import {
  AcknowledgeCardWrapper,
  AcknowledgeCardIcon,
  AcknowledgeCardHeader,
  AcknowledgeCardDescription,
  AcknowledgeCardBranding
} from './index.style';

interface IAcknowledgeCard {
  data: {
    icon: string;
    title: string;
    description: string;
    brandingMsg: string;
  };
}
const AcknowledgeCard: React.FC<IAcknowledgeCard> = ({ data }) =>
  data && (
    <AcknowledgeCardWrapper>
      <AcknowledgeCardIcon src={data.icon || ''} alt="check-icon" />
      <AcknowledgeCardHeader>{data.title || ''}</AcknowledgeCardHeader>
      <AcknowledgeCardDescription>{data.description || ''}</AcknowledgeCardDescription>
      <AcknowledgeCardBranding>{data.brandingMsg || ''}</AcknowledgeCardBranding>
    </AcknowledgeCardWrapper>
  );

export default AcknowledgeCard;
